function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.55,
    height: 50.2,
    viewBox: "0 0 38.55 50.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-pdf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2648",
    "data-name": "Grupo 2648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1276",
    "data-name": "Caminho 1276",
    d: "M27.33,0h-26C.59,0,0,.59,0,1.73V49.3a1.35,1.35,0,0,0,1.31.9H37.23a1.36,1.36,0,0,0,1.32-.9V11.63c0-.62-.09-.82-.23-1L27.88.23A.75.75,0,0,0,27.33,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1277",
    "data-name": "Caminho 1277",
    d: "M27.79.13V10.76H38.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1278",
    "data-name": "Caminho 1278",
    d: "M11.67,29.87h0a1.44,1.44,0,0,1-.87-.29,2.17,2.17,0,0,1-1-2c.16-1.46,2-3,5.37-4.54a61,61,0,0,0,3.4-9.64c-.9-2-1.77-4.47-1.13-5.95a1.71,1.71,0,0,1,1-1.09,4.14,4.14,0,0,1,.91-.16c.46,0,.85.59,1.13.94s.87,1-.33,6.1A28.8,28.8,0,0,0,24.72,20a17.88,17.88,0,0,1,3-.32c1.4,0,2.26.33,2.6,1A1.8,1.8,0,0,1,30,22.63a2.4,2.4,0,0,1-2,1.07c-1.09,0-2.36-.69-3.77-2.05a42.22,42.22,0,0,0-7.92,2.53A25.45,25.45,0,0,1,14.16,28C13.24,29.27,12.45,29.87,11.67,29.87Zm2.38-4.59c-1.91,1.07-2.7,2-2.75,2.46,0,.08,0,.3.39.62.13,0,.91-.4,2.36-3.08Zm12.23-4c.73.56.91.84,1.39.84a1.32,1.32,0,0,0,1.08-.4,1.36,1.36,0,0,0,.21-.37c-.11-.06-.26-.18-1.06-.18a12.6,12.6,0,0,0-1.62.11Zm-6.7-5.9a63.49,63.49,0,0,1-2.4,6.78A44.07,44.07,0,0,1,23,20.36a30.58,30.58,0,0,1-3.42-5ZM19,7.81a2.16,2.16,0,0,0,.09,2.88C20,8.8,19.07,7.8,19,7.81Z",
    style: {
      fill: "#cc4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1279",
    "data-name": "Caminho 1279",
    d: "M37.23,50.2H1.31A1.31,1.31,0,0,1,0,48.89H0V35H38.54V48.89a1.3,1.3,0,0,1-1.3,1.31Z",
    style: {
      fill: "#cc4c4c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1280",
    "data-name": "Caminho 1280",
    d: "M9.76,47.51H8.29v-9h2.6a3.72,3.72,0,0,1,1.14.18,3.31,3.31,0,0,1,1,.55,2.94,2.94,0,0,1,.72.89A2.49,2.49,0,0,1,14,41.27a3.26,3.26,0,0,1-.24,1.24,2.45,2.45,0,0,1-.65.94,3,3,0,0,1-1,.59,4.07,4.07,0,0,1-1.3.21H9.76v3.26Zm0-7.92v3.58h1.35a1.6,1.6,0,0,0,.53-.09,1.5,1.5,0,0,0,.48-.3,1.42,1.42,0,0,0,.36-.58,2.68,2.68,0,0,0,.13-.93,2.22,2.22,0,0,0-.06-.51,1.44,1.44,0,0,0-.25-.55,1.51,1.51,0,0,0-.53-.44,2.06,2.06,0,0,0-.91-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1281",
    "data-name": "Caminho 1281",
    d: "M23.05,42.74a6.45,6.45,0,0,1-.23,1.91A5,5,0,0,1,22.21,46a3,3,0,0,1-.83.84,3.58,3.58,0,0,1-.89.46,3.44,3.44,0,0,1-.78.2,4.55,4.55,0,0,1-.53,0H15.76v-9h2.72a5.1,5.1,0,0,1,2,.36,4,4,0,0,1,1.43,1,3.76,3.76,0,0,1,.85,1.37A4.41,4.41,0,0,1,23.05,42.74Zm-4.36,3.69a2.43,2.43,0,0,0,2.16-1,4.87,4.87,0,0,0,.66-2.77,4.61,4.61,0,0,0-.13-1.11,2.4,2.4,0,0,0-.52-1,2.71,2.71,0,0,0-1.05-.72,4.38,4.38,0,0,0-1.72-.28h-.86v6.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1282",
    "data-name": "Caminho 1282",
    d: "M26.68,39.59v2.85h3.78v1H26.68V47.5H25.19v-9h5.65v1.11Z",
    style: {
      fill: "#fff"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPdf);
export default __webpack_public_path__ + "static/media/ico-pdf.83c286440e4f925aee373f486f324183.svg";
export { ForwardRef as ReactComponent };